import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addScreenAction, updateScreenAction } from "../actions";
import { START, WATER_TYPE } from "../constants";

function GetStarted({ dispatch, screens, updateScreen, addScreen }) {
  const step = 0;

  return (
    <div className="uk-relative uk-flex page-container">
      <div
        id={"get-started"}
        className={`get-started uk-height-1-1 uk-margin-large-top ${
          step === 0 ? "" : "uk-hidden"
        }`}
      >
        <div className="uk-card uk-card-default uk-card-body uk-padding uk-position-small@m uk-flex-col uk-position-z-index uk-text-center uk-width-1-1 uk-width-2-3@s uk-text-left@s">
          <>
            <h1>Pump Selector Tool! </h1>
            <h4>Find the right pump solution for the job at hand.</h4>
            <button
              className="next uk-button uk-button-primary"
              tabidex="0"
              onClick={() => {
                updateScreen({
                  curr_screen: START,
                  next_screen: WATER_TYPE,
                });
              }}
            >
              Get Started
            </button>
          </>
          <hr />
          <div className="find-branch">
            <p>
              Prefer to talk to a person? Contact your local Reece Irrigation &
              Pools branch for expert advice and recommendations.
            </p>
            <a
              className="uk-button uk-button-default"
              href="https://www.reece.com.au/storefinder"
              target="_blank"
              rel="noopener noreferrer"
            >
              FIND A BRANCH
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(GetStarted);
